<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Declaración de Asegurabilidad</h6>
            </template>

            <p class="text-muted mb-3">
              Declaro que:
            </p>

            <!-- Declaración 1 -->
            <div class="declaracion-item">
              <span class="declaracion-numero">1.</span>
              <span class="declaracion-texto">
                Tanto mis actividades como ocupación son lícitas y en consecuencia
                los bienes que poseo provienen de medios lícitos. Igualmente declaro
                que no he sido objeto de amenazas, de secuestro o muerte ni me han
                solicitado contribuciones para evitarlo.
              </span>
            </div>

            <!-- Declaración 2 -->
            <div class="declaracion-item">
              <span class="declaracion-numero">2.</span>
              <span class="declaracion-texto">
                Autorizo permanente e irrevocablemente a PAN AMERICAN LIFE DE
                COLOMBIA COMPAÑÍA DE SEGUROS S.A., para que a partir de la fecha
                procese, conserve o actualice cualquier información de carácter
                financiero o comercial y la autorizo para que reporte, consulte o
                suministre esta información a las centrales de información o bases
                de datos debidamente constituidas, en los términos y durante el
                tiempo que la ley lo establezca.
              </span>
            </div>

            <!-- Declaración 3 -->
            <div class="declaracion-item">
              <span class="declaracion-numero">3.</span>
              <span class="declaracion-texto">
                Autorizo expresamente, aún después de mi fallecimiento, a los
                médicos e instituciones de salud a proporcionar a los Beneficiarios
                de este seguro y a PAN AMERICAN LIFE DE COLOMBIA COMPAÑÍA DE
                SEGUROS S.A., copia de mi historia médica clínica, resultados de
                medios diagnósticos y cualquier información o registro que hayan
                efectuado o efectúen. En consecuencia renuncio en mi propio nombre
                y en el de cualquier tercero interesado, a todas las disposiciones
                de ley que prohíban a los médicos, centros asistenciales o de
                diagnóstico que me hayan atendido, revelar cualquier información
                adquirida con motivo de diagnóstico o tratamiento.
              </span>
            </div>

            <!-- Declaración 4 -->
            <div class="declaracion-item">
              <span class="declaracion-numero">4.</span>
              <span class="declaracion-texto">
                He sido advertido de mi obligación de declarar sinceramente mi
                estado de salud y cualquier diagnóstico, tratamiento, patología que
                tenga o haya tenido y las consecuencias de tal omisión, por lo cual
                manifiesto que todas las declaraciones efectuadas en esta solicitud
                son completas y verídicas. Acepto que PAN AMERICAN LIFE DE COLOMBIA
                COMPAÑÍA DE SEGUROS S.A., se reserva los derechos que puedan
                asistirle en caso que antes o después de mi fallecimiento, se
                compruebe que esta declaración no corresponde a la realidad
                (Artículos 1058, 1158 y 1161 del Código de Comercio).
              </span>
            </div>

            <!-- Declaración 5 -->
            <div class="declaracion-item">
              <span class="declaracion-numero">5.</span>
              <span class="declaracion-texto">
                He leído, revisado, entendido y recibido todas y cada una de las
                condiciones, del anverso y reverso, del presente certificado, que
                conozco su contenido, cuáles son mis deberes, obligaciones,
                derechos, los costos y gastos que le son inherentes y sus
                consecuencias legales y con mi firma acepto integralmente su
                contenido.
              </span>
            </div>

            <!-- Declaración 6 -->
            <div class="declaracion-item">
              <span class="declaracion-numero">6.</span>
              <span class="declaracion-texto">
                Que conozco y puedo acceder al Manual de Políticas de Datos
                Personales de la Compañía y al aviso de privacidad en www.palig.com
              </span>
            </div>

            <b-form-group class="mt-4 mb-0">
              <b-form-checkbox v-model="form.declarationsAccepted" name="declarationsAccepted">
                Declaro que he leído, entendido y acepto en su totalidad las
                declaraciones anteriores.
              </b-form-checkbox>
            </b-form-group>

            <b-row align-h="end" class="mt-4">
              <b-col cols="12" md="4" class="d-flex justify-content-end">
                <b-button @click="previous" variant="secondary" class="mr-2">
                  Anterior
                </b-button>
                <b-button type="submit" variant="primary" :disabled="!form.declarationsAccepted" >
                  Firmar
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "FormColombia04",
  data() {
    return { form: {} };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/vida/");
      return;
    }
    this.form = {...form, declarationsAccepted: false};
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 3, form: this.form })
        .then(() => this.$router.push("/form/colombia-vida-3.html"));
    },
    next() {
      if (!this.form.declarationsAccepted) {
        return;
      }
      this.$store
        .dispatch("wizard/save", { index: 4, form: this.form })
        .then(() => this.$router.push("/form/colombia-vida-5.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}

.declaracion-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.declaracion-item:last-of-type {
  border-bottom: none;
}

.declaracion-numero {
  font-weight: bold;
  flex-shrink: 0;
}

.declaracion-texto {
  flex: 1;
  min-width: 0;
  font-size: 0.95rem;
  text-align: justify;
}
</style>
